import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';
import { useAnalyticsConsent, writeConsent } from '../../lib/analytics';
import { Button } from '../ui/button';

// Компактна плашка знизу по центру, як у великих українських магазинів: одне речення,
// «ПРИЙНЯТИ» і «ДЕТАЛЬНІШЕ». Детальніше розкриває пояснення і кнопку «ВІДХИЛИТИ» — відмова
// лишається справжньою, на один клік. Сховано на /privacy, щоб не закривати політику.
export function CookieConsent() {
  const { data: config } = useConfig();
  const { data: user, isLoading } = useAuth();
  const consent = useAnalyticsConsent();
  const { pathname } = useLocation();
  const [expanded, setExpanded] = useState(false);

  const visible =
    !isLoading &&
    Boolean(config?.gaMeasurementId) &&
    consent === null &&
    user?.role !== 'admin' &&
    pathname !== '/privacy';

  if (!visible) return null;

  return (
    <section
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      className="fixed bottom-4 left-1/2 z-[60] max-h-[calc(100dvh-32px)] w-[calc(100%-32px)] max-w-[560px] -translate-x-1/2 overflow-y-auto border border-accent bg-surface p-5 text-center"
    >
      <h2 id="cookie-consent-title" className="sr-only">
        Cookie і аналітика
      </h2>
      <p className="m-0 mb-4 text-[15px] leading-relaxed text-ink">
        Ми використовуємо cookie, щоб зробити сайт зручнішим для вас. Імен і контактів вони не
        збирають, а вмикаються лише за вашою згодою.
      </p>
      {expanded && (
        <div
          id="cookie-consent-details"
          className="mb-4 space-y-3 border-t border-line pt-4 text-left text-[14px] leading-relaxed text-muted"
        >
          <p className="m-0">
            Частина cookie потрібна для роботи сайту: вони дозволяють увійти в акаунт і оформити
            замовлення, тому вмикаються завжди.
          </p>
          <p className="m-0">
            Інші належать Google Analytics: вони допомагають зрозуміти, які сторінки відвідують і що
            варто покращити. Реклами на сайті немає, і ваші дані для реклами ми не передаємо.
          </p>
          <p className="m-0">
            Погодитися чи відмовитися можна вільно: сайт працює однаково. Змінити вибір можна
            будь-коли в розділі «Аналітика та cookie» нашої{' '}
            <Link to="/privacy" className="text-accent no-underline">
              Політики конфіденційності
            </Link>
            .
          </p>
        </div>
      )}
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button
          variant="accent"
          size="md"
          className="flex-1"
          onClick={() => writeConsent('granted')}
        >
          ПРИЙНЯТИ
        </Button>
        {expanded ? (
          <Button
            variant="secondary"
            size="md"
            className="flex-1"
            onClick={() => writeConsent('denied')}
          >
            ВІДХИЛИТИ
          </Button>
        ) : (
          <Button
            variant="secondary"
            size="md"
            className="flex-1"
            aria-expanded={false}
            aria-controls="cookie-consent-details"
            onClick={() => setExpanded(true)}
          >
            ДЕТАЛЬНІШЕ
          </Button>
        )}
      </div>
    </section>
  );
}
